module.exports = __webpack_public_path__ + "img/r-198.e398369b.jpg";